module.exports = {
      id: "youtube-usage",
      viewBox: "0 0 26 18",
      url: "/" + "sprite-bc5ff1507898764e0c54e53c34039c01.svg#youtube",
      toString: function () {
        return this.url;
      }
    }